import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import { withRouter } from "react-router-dom";

import WizardForm from "./WizardForm";

import service from "../../../../../../services/api";
import { vehiclesByLicensePlate } from "../../../../../../utils/request";
import { useGarage } from "../../../../../../garage/GarageContext";

function NewVehicle({ history }) {
  const [loading, setLoading] = useState(false);
  const { reload } = useGarage();

  async function checkVehicle(License_Plate) {
    const response = await vehiclesByLicensePlate(License_Plate);
    let check;
    try {
      if (response.payload.length > 0) {
        return (check = true);
      }
    } catch {
      return (check = false);
    }
    return check;
  }

  async function submit(values) {
    const { licensePlate, brand, model } = values;
    try {
      setLoading(true);

      const check = await checkVehicle(licensePlate.replace("-", ""));

      if (check) {
        setLoading(false);
        return toastr.warning("Veículo já cadastrado");
      }

      await service.api.post(service.config.endpoint + `vehicles`, {
        licensePlate: licensePlate.replace("-", ""),
        brand: brand.label,
        model: model.label,
      });
      // A garagem e o historico sao carregados uma vez no layout; recarrega com o veiculo novo.
      reload();
      history.push("/client/vehicles");
      return toastr.success("Veículo adicionado à sua garagem!");
    } catch (err) {
      console.log(err);
      toastr.error(
        "Ocorreu um erro ao cadastrar o veículo. Por favor, tente novamente"
      );
    } finally {
      setLoading(false);
    }
  }

  return <WizardForm onSubmit={submit} loading={loading} />;
}

export default withRouter(NewVehicle);
